import React from "react";
import { useNavigate } from "react-router-dom";
import Main from "../../components/layout/Main";
import GamesImage from "../../assets/images/games-image.jpg";
import BreadcrumbArrow from "../../assets/images/breadcrumb-image-arrow.svg";
import LeaderboardProfile from "../../assets/images/leaderboard-profile.jpg";
import TrophyImage from "../../assets/images/trofies-image.svg";
import { Breadcrumb } from "antd";

const SelectGame = () => {
  const navigate = useNavigate();

  const title = "Select Game Version";

  const data = [
    { image: GamesImage },
    { image: GamesImage },
    { image: GamesImage },
  ];
  const players = [
    { name: "PlayerOne", points: 128 },
    { name: "PlayerTwo", points: 115 },
    { name: "PlayerThree", points: 97 },
    { name: "PlayerFour", points: 89 },
    { name: "PlayerFive", points: 75 },
  ];
  return (
    <Main>
      <Breadcrumb
        className="for-route-path-head"
        separator={<img src={BreadcrumbArrow} />}
      >
        <Breadcrumb.Item
          onClick={() => navigate("/")}
          style={{ cursor: "pointer" }}
        >
          Tournament
        </Breadcrumb.Item>
        <Breadcrumb.Item>Games</Breadcrumb.Item>
        <Breadcrumb.Item>Call of Duty</Breadcrumb.Item>
      </Breadcrumb>
      <div className="">
        <div className="section-header">
          <div className="orange-header">{title}</div>
          {/* <span className="view-all" onClick={() => navigate(-1)}>Back</span> */}
        </div>

        <div className="main-grid-new">
          {data.map((item, index) => (
            <div
              key={index}
              className="game-card"
              onClick={() => navigate("/selectedgames-tournaments")}
            >
              <div className="games-image-k">
                <img
                  src={item.image}
                  alt={`Game ${index + 1}`}
                  className="game-image"
                />
              </div>
              <div className="game-version">
                <h4> Modern Warfare 2019 </h4>
                <h6> The game that started the modern era </h6>
              </div>
            </div>
          ))}
        </div>
        {/* <div className="leaderboard-main-section">
          <div className="leaderboard-header">
            <h4>Leaderboard</h4>
            <h6>Refresh</h6>
          </div>
          {players.map((player, index) => (
        <div className="leaderboard-list" key={index} >
          <div className="leaderboard-list-player">
            <span>{index + 1}</span>
            <div className="leaderboard-player-profile">
              <img src={LeaderboardProfile} alt={player.name} />
            </div>
            <div className="leaderboard-player-name">{player.name}</div>
          </div>
          <div className="leaderboard-points">
            <h4>{player.points} pts</h4>
            <img src={TrophyImage} alt="Trophy" />
          </div>
        </div>
      ))}
      <div className="leaderboard-header">
            <h4>    </h4>
            <h6>View Full Leaderboard</h6>
          </div>
        </div> */}
      </div>
    </Main>
  );
};

export default SelectGame;
